<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter701negotiations">CHAPTER 701 - NEGOTIATIONS</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter702completionofseclusion">CHAPTER 702 - COMPLETION OF SECLUSION</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter703justintime">CHAPTER 703 - JUST IN TIME</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter704halfyeartime">CHAPTER 704 - HALF YEAR TIME</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter705reachinginfinity">CHAPTER 705 - REACHING INFINITY</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter706citygatewindwave">CHAPTER 706 - CITY GATE WIND WAVE</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter707selectionstart">CHAPTER 707 - SELECTION START</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter708enemieshaveanarrowroad">CHAPTER 708 - ENEMIES HAVE A NARROW ROAD</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter709evenlymatched" title="Link target outside of Sample">CHAPTER 709 - EVENLY MATCHED</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter710callingattention" title="Link target outside of Sample">CHAPTER 710 - CALLING ATTENTION</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter711sendyourselftothedoor" title="Link target outside of Sample">CHAPTER 711 - SEND YOURSELF TO THE DOOR</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter712itwasjustateamannihilation" title="Link target outside of Sample">CHAPTER 712 - IT WAS JUST A TEAM ANNIHILATION …</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter713enter1000" title="Link target outside of Sample">CHAPTER 713 - ENTER 1000</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter714initialconversation" title="Link target outside of Sample">CHAPTER 714 - INITIAL CONVERSATION</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter715agreedstrategies" title="Link target outside of Sample">CHAPTER 715 - AGREED STRATEGIES</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter716senddownwarnotes" title="Link target outside of Sample">CHAPTER 716 - SEND DOWN WAR NOTES</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter717profoundsealcompetition" title="Link target outside of Sample">CHAPTER 717 - PROFOUND SEAL COMPETITION</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter718mountainandriverseal" title="Link target outside of Sample">CHAPTER 718 - MOUNTAIN AND RIVER SEAL</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter719theharvestwasplentiful" title="Link target outside of Sample">CHAPTER 719 - THE HARVEST WAS PLENTIFUL</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter720fightingbetweenthestrong" title="Link target outside of Sample">CHAPTER 720 - FIGHTING BETWEEN THE STRONG</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter721killleft" title="Link target outside of Sample">CHAPTER 721 - KILL LEFT</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter722ancientrunes" title="Link target outside of Sample">CHAPTER 722 - ANCIENT RUNES</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter723ninthleaf" title="Link target outside of Sample">CHAPTER 723 - NINTH LEAF</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter724lightofenlightenment" title="Link target outside of Sample">CHAPTER 724 - LIGHT OF ENLIGHTENMENT</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter725thunderoustransformation" title="Link target outside of Sample">CHAPTER 725 - THUNDEROUS TRANSFORMATION</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter726kingsovereignappeared" title="Link target outside of Sample">CHAPTER 726 - KING SOVEREIGN APPEARED</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter727everyonebreakthrough" title="Link target outside of Sample">CHAPTER 727 - EVERYONE BREAK THROUGH</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter728fighttothedeath" title="Link target outside of Sample">CHAPTER 728 - FIGHT TO THE DEATH</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter729haveyouhadenough" title="Link target outside of Sample">CHAPTER 729 - HAVE YOU HAD ENOUGH?</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter730killingthekingsovereign" title="Link target outside of Sample">CHAPTER 730 - KILLING THE KING SOVEREIGN</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter731handlingofpostmortemmatters" title="Link target outside of Sample">CHAPTER 731 - HANDLING OF POST-MORTEM MATTERS</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter732centralzone" title="Link target outside of Sample">CHAPTER 732 - CENTRAL ZONE</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter733tenstoneplatforms" title="Link target outside of Sample">CHAPTER 733 - TEN STONE PLATFORMS</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter734crueltytofight" title="Link target outside of Sample">CHAPTER 734 - CRUELTY TO FIGHT</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter735ascendthestoneplatform" title="Link target outside of Sample">CHAPTER 735 - ASCEND THE STONE PLATFORM</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter736directlyfacingkingsovereign" title="Link target outside of Sample">CHAPTER 736 - DIRECTLY FACING KING SOVEREIGN</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter737againcuttingkingsovereign" title="Link target outside of Sample">CHAPTER 737 - AGAIN CUTTING KING SOVEREIGN</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter738thousands" title="Link target outside of Sample">CHAPTER 738 - THOUSANDS</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter739competitionforthetop1001" title="Link target outside of Sample">CHAPTER 739 - COMPETITION FOR THE TOP 100 (1)</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter740competitionforthetop1002" title="Link target outside of Sample">CHAPTER 740 - COMPETITION FOR THE TOP 100 (2)</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter741competitionforthetop1003" title="Link target outside of Sample">CHAPTER 741 - COMPETITION FOR THE TOP 100 (3)</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter742competitionforthetop1004" title="Link target outside of Sample">CHAPTER 742 - COMPETITION FOR THE TOP 100 (4)</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter743competitionforthetop1005" title="Link target outside of Sample">CHAPTER 743 - COMPETITION FOR THE TOP 100 (5)</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter744retreatwithoutafight" title="Link target outside of Sample">CHAPTER 744 - RETREAT WITHOUT A FIGHT</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter745finalwari" title="Link target outside of Sample">CHAPTER 745 - FINAL WAR (I)</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter746finalwarii" title="Link target outside of Sample">CHAPTER 746 - FINAL WAR (II)</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter747finalwariii" title="Link target outside of Sample">CHAPTER 747 - FINAL WAR (III)</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter748finalbattle4" title="Link target outside of Sample">CHAPTER 748 - FINAL BATTLE (4)</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter749finalwarv" title="Link target outside of Sample">CHAPTER 749 - FINAL WAR (V)</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter750warsealcontesti" title="Link target outside of Sample">CHAPTER 750 - WAR SEAL CONTEST (I)</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter751warsealcontest2" title="Link target outside of Sample">CHAPTER 751 - WAR SEAL CONTEST (2)</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter752warofthewarsealcontest3" title="Link target outside of Sample">CHAPTER 752 - WAR OF THE WAR SEAL CONTEST (3)</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter753warsealcontest4" title="Link target outside of Sample">CHAPTER 753 - WAR SEAL CONTEST (4)</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter754warsealcontest5" title="Link target outside of Sample">CHAPTER 754 - WAR SEAL CONTEST (5)</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter755cardiacarrayillusorydragonarray" title="Link target outside of Sample">CHAPTER 755 - CARDIAC ARRAY ILLUSORY DRAGON ARRAY</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter756afewmore" title="Link target outside of Sample">CHAPTER 756 - A FEW MORE</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter757fightagainstqintian" title="Link target outside of Sample">CHAPTER 757 - FIGHT AGAINST QIN TIAN</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter758evenlymatched" title="Link target outside of Sample">CHAPTER 758 - EVENLY MATCHED</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter759stillnessinbattle" title="Link target outside of Sample">CHAPTER 759 - STILLNESS IN BATTLE</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter760endofcompetition" title="Link target outside of Sample">CHAPTER 760 - END OF COMPETITION</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter761fiveimmortalartifacts" title="Link target outside of Sample">CHAPTER 761 - FIVE IMMORTAL ARTIFACTS</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter762supremedharmabody" title="Link target outside of Sample">CHAPTER 762 - SUPREME DHARMA BODY</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter763qintianjoined" title="Link target outside of Sample">CHAPTER 763 - QIN TIAN JOINED</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter764onhiswayhome" title="Link target outside of Sample">CHAPTER 764 - ON HIS WAY HOME</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter765astrongsouthernprefecture" title="Link target outside of Sample">CHAPTER 765 - A STRONG SOUTHERN PREFECTURE</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter766mafamily" title="Link target outside of Sample">CHAPTER 766 - MA FAMILY</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter767goodbyetosutong" title="Link target outside of Sample">CHAPTER 767 - GOODBYE TO SU TONG</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter768onhiswaytothelostland" title="Link target outside of Sample">CHAPTER 768 - ON HIS WAY TO THE LOST LAND.</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter769seetheoldman" title="Link target outside of Sample">CHAPTER 769 - SEE THE OLD MAN</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter770returntotianluo" title="Link target outside of Sample">CHAPTER 770 - RETURN TO TIAN LUO</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter771southernprefecturecorrection" title="Link target outside of Sample">CHAPTER 771 - SOUTHERN PREFECTURE CORRECTION</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter772demonessfromthedemonrace" title="Link target outside of Sample">CHAPTER 772 - DEMONESS FROM THE DEMON RACE</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter773wheredidyoucomefromgobacktowhere" title="Link target outside of Sample">CHAPTER 773 - 'WHERE DID YOU COME FROM? GO BACK TO WHERE? '</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter774apologizeordie" title="Link target outside of Sample">CHAPTER 774 - APOLOGIZE OR DIE!</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter775demonlordsclone" title="Link target outside of Sample">CHAPTER 775 - DEMON LORD'S CLONE</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter776demonsandevils" title="Link target outside of Sample">CHAPTER 776 - DEMONS AND EVILS</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter777twopeopletranscendingtribulation" title="Link target outside of Sample">CHAPTER 777 - TWO PEOPLE TRANSCENDING TRIBULATION</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter778newlyaddedhand" title="Link target outside of Sample">CHAPTER 778 - NEWLY-ADDED HAND</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter779demonmovement" title="Link target outside of Sample">CHAPTER 779 - DEMON MOVEMENT</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter780seclusionagain" title="Link target outside of Sample">CHAPTER 780 - SECLUSION AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter781cranedescendant" title="Link target outside of Sample">CHAPTER 781 - CRANE DESCENDANT</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter782impactfailure" title="Link target outside of Sample">CHAPTER 782 - IMPACT FAILURE</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter783desolateswamp" title="Link target outside of Sample">CHAPTER 783 - DESOLATE SWAMP</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter784enteringdesolateswamp" title="Link target outside of Sample">CHAPTER 784 - ENTERING DESOLATE SWAMP</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter785craneclan" title="Link target outside of Sample">CHAPTER 785 - CRANE CLAN</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter786leavingthedesolateswamp" title="Link target outside of Sample">CHAPTER 786 - LEAVING THE DESOLATE SWAMP</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter787chiefofthecraneclan" title="Link target outside of Sample">CHAPTER 787 - CHIEF OF THE CRANE CLAN</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter788soaringsnakes" title="Link target outside of Sample">CHAPTER 788 - SOARING SNAKES</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter789herbatetrandrae" title="Link target outside of Sample">CHAPTER 789 - HERBA TETRANDRAE</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter790leavingthecraneclan" title="Link target outside of Sample">CHAPTER 790 - LEAVING THE CRANE CLAN</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter791thetwolittleguysareback" title="Link target outside of Sample">CHAPTER 791 - THE TWO LITTLE GUYS ARE BACK</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter792peoplesmeeting" title="Link target outside of Sample">CHAPTER 792 - PEOPLE'S MEETING</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter793linfansaccident" title="Link target outside of Sample">CHAPTER 793 - LIN FAN'S ACCIDENT</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter794qingyunsectexterminated" title="Link target outside of Sample">CHAPTER 794 - QING-YUN SECT EXTERMINATED</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter795demonblackhand" title="Link target outside of Sample">CHAPTER 795 - DEMON BLACK HAND</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter796tokillthedemons" title="Link target outside of Sample">CHAPTER 796 - TO KILL THE DEMONS</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter797decisiveaction" title="Link target outside of Sample">CHAPTER 797 - DECISIVE ACTION</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter798fightingagainstthedemonlord" title="Link target outside of Sample">CHAPTER 798 - FIGHTING AGAINST THE DEMON LORD</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter799thedemongodkowtowed" title="Link target outside of Sample">CHAPTER 799 - THE DEMON GOD KOWTOWED</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter800fighttothedeath" title="Link target outside of Sample">CHAPTER 800 - FIGHT TO THE DEATH</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?30ffeed8